// **************
// PAGE IDs
// **************
export const PAGE_VEHICLE_SELECTION: string = "vehicle-selection";
export const PAGE_HOME: string = "home";
export const PAGE_NEXT_STEPS: string = "next-steps";
export const PAGE_ERROR: string = "error";
export const PAGE_ADVANTAGES: string = "advantages";
export const PAGE_CHARGING: string = "charging";
export const PAGE_CUSTOMISE: string = "customise";
export const PAGE_FEATURES: string = "features";
export const PAGE_FINANCE: string = "finance";
export const PAGE_GALLERY: string = "gallery";
export const PAGE_SPECIFICATIONS: string = "specifications";

// **************
// MODAL IDs
// **************
export const MODAL_VEHICLE_SELECTOR: string = "vehicle-selector";
export const MODAL_SPECIAL_OFFERS: string = "special-offers";
export const MODAL_QTVR: string = "qtvr";
